<!-- 试题管理 -->
<template>
  <div class="el-ErrorSet">
    <el-row class="content_block">
      <TitleInfo title="试题管理" :titleImg="zjie"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-row style="margin-bottom: 20px;">
          <label>题干：</label>
          <el-input placeholder="请输入题干" style="width: 200px;" prefix-icon="el-icon-search" v-model="search.questionStem"></el-input>
          <label class="ml10">课程筛选：</label>
          <el-select @change="getCourseInfoList" clearable style="width: 160px;" v-model="search.teacherOpenCourseId" placeholder="请选择课程">
            <template v-for="(item ,index) in courseList">
              <el-option :label="item.teacherOpenCourseIdText || item.teacherOpenCourseTitle" :value="item.teacherOpenCourseId"></el-option>
            </template>
          </el-select>
          <label class="ml10">章目录筛选：</label>
          <el-select clearable style="width: 160px;" v-model="search.teacherOpenCourseMergeCourseInfoId" placeholder="请选择章目录">
            <template v-for="(item ,index) in courseInfoList">
              <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
            </template>
          </el-select>
          <label class="ml10">状态：</label>
          <el-select clearable v-model="search.questionStatus" style="width: 100px;" placeholder="状态">
            <el-option label="已上架" value="1"></el-option>
            <el-option label="已下架" value="2"></el-option>
          </el-select>
          <el-button-group>
            <el-button type="primary" size="medium" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
            <el-button type="success" size="medium" icon="el-icon-plus" @click="addQuestionInfo">新增</el-button>
            <el-button type="success" size="medium" icon="el-icon-printer" @click="exportInfo">导入</el-button>
            <!-- <el-button type="success" size="medium" icon="el-icon-delete" @click="delInfo">删除</el-button> -->
          </el-button-group>
        </el-row>
        <el-row>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
            <el-table-column prop="questionStem" header-align="center" align="left" label="题干">
              <template slot-scope="scope">
                <el-row v-html="$getReplace(scope.row.questionStem)"></el-row>
              </template>
            </el-table-column>
            <el-table-column prop="questionType" header-align="center" align="center" label="题型"  width="100">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false">{{$retQuestionType(scope.row.questionType)}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="teacherOpenCourseIdText" header-align="center" align="center" label="归属课程" width="200"> </el-table-column>
            <el-table-column prop="teacherOpenCourseMergeCourseInfoIdText" header-align="center" align="center" label="归属章节" width="150"> </el-table-column>
            <el-table-column prop="scyx" header-align="center" align="center" label="上传院校" width="150"> </el-table-column>
            <el-table-column prop="questionStatus" header-align="center" align="center" label="状态" width="100">
              <template slot-scope="scope">
                <el-link :type="scope.row.questionStatus==1?'primary':'danger'" :underline="false">{{scope.row.questionStatus == 1?"已上架":"已下架"}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="cz_" header-align="center" align="center" label="操作" width="240">
              <template slot-scope="scope">
                <el-link type="primary" v-if="scope.row.questionStatus == 2 || $isEmpty(scope.row.questionStatus)" class="mr20" :underline="false" @click="putShelves(scope.row,1)">上架</el-link>
                <el-link type="primary" v-if="scope.row.questionStatus == 1" class="mr20" :underline="false" @click="putShelves(scope.row,2)">下架</el-link>
                <el-link type="primary" class="mr20" :underline="false" @click="editInfo(scope.row)">编辑</el-link>
                <el-link type="danger" class="mr20" :underline="false" @click="delInfo(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              background
              :hide-on-single-page="false"
              layout="sizes, prev, pager, next,jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>

      <!-- 新增试题 -->
      <el-dialog
        title="新增试题"
        :visible.sync="addShow"
        width="1000px"
      >
        <span slot="title">
          <i class="el-icon-plus" style="margin-right: 10px;color: #67C23A;"></i>新增试题
        </span>
        <el-form ref="addInfo" :model="addInfo" label-width="100px">
          <el-form-item label="归属课程">
            <el-input :value="addInfoCourseName" disabled placeholder="当前课程">
              <i slot="prefix" class="el-icon-lock" style="color:#909399;"></i>
            </el-input>
            <div class="course-tip">{{ $isEmpty(addInfo.teacherOpenCourseMergeResourcesQuestionId) ? '已自动锁定为当前进入的课程，无需选择' : '该试题的归属课程，编辑时不可修改' }}</div>
          </el-form-item>
          <el-form-item label="归属章节">
            <el-select clearable style="width: 100%;" v-model="addInfo.teacherOpenCourseMergeCourseInfoId" placeholder="请选择章节" no-data-text="该课程暂无章节目录">
              <template v-for="(item ,index) in courseInfoList_add">
                <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="题型">
            <el-select @change="questionAnswerChange" clearable style="width: 100%;" v-model="addInfo.questionType" placeholder="请选择题型">
              <el-option label="单选题" :value="1"></el-option>
              <el-option label="多选题" :value="2"></el-option>
              <el-option label="判断题" :value="3"></el-option>
              <el-option label="填空题" :value="4"></el-option>
              <el-option label="分析题" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分值">
            <el-input ref="scoreInput" v-model="addInfo.questionScore" @input.native="onScoreInput" placeholder="请输入分值"></el-input>
          </el-form-item>
          <el-form-item label="题干">
            <!-- 单选、多选、判断时使用普通富文本 -->
            <RichText ref="richText" v-if="addShow && addInfo.questionType <= 3" v-model="addInfo.questionStem" />
            <editorMd editorId="editorAssessmentContent" v-if="addShow && addInfo.questionType > 3" height="500px" @onChangeContent="changeValue" :modelValue="addInfo.questionStem"></editorMd>
          </el-form-item>
          <!-- 单选题 -->
          <template v-if="addInfo.questionType == 1">
            <el-row>
              <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                选项 <el-radio v-model="addInfo.questionAnswer" label="A" class="mr20"></el-radio>
              </label>
              <div style="width: calc(100% - 100px);float: left;">
                <RichText ref="richTextA" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionA" />
              </div>
              <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionA"></el-input> -->
            </el-row>
            <el-row class="mt10">
              <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                <el-radio v-model="addInfo.questionAnswer" label="B" class="mr20"></el-radio>
              </label>
              <div style="width: calc(100% - 100px);float: left;">
                <RichText ref="richTextB" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionB" />
              </div>
              <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionB"></el-input> -->
            </el-row>
            <el-row class="mt10">
              <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                <el-radio v-model="addInfo.questionAnswer" label="C" class="mr20"></el-radio>
              </label>
              <div style="width: calc(100% - 100px);float: left;">
                <RichText ref="richTextC" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionC" />
              </div>
              <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionC"></el-input> -->
            </el-row>
            <el-row class="mt10">
              <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                <el-radio v-model="addInfo.questionAnswer" label="D" class="mr20"></el-radio>
              </label>
              <div style="width: calc(100% - 100px);float: left;">
                <RichText ref="richTextD" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionD" />
              </div>
              <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionD"></el-input> -->
            </el-row>
            <el-row class="mt10">
              <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                <el-radio v-model="addInfo.questionAnswer" label="E" class="mr20"></el-radio>
              </label>
              <div style="width: calc(100% - 100px);float: left;">
                <RichText ref="richTextE" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionE" />
              </div>
              <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionE"></el-input> -->
            </el-row>
          </template>
          <!-- 多选题 -->
          <template v-if="addInfo.questionType == 2">
            <el-checkbox-group v-model="questionAnswerList" @change="handleCheckedCitiesChange">
              <el-row>
                <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                  <span style="font-size: 12px;margin-right: 5px;">选项</span><el-checkbox label="A" class="mr20"></el-checkbox>
                </label>
                <div style="width: calc(100% - 100px);float: left;">
                  <RichText ref="richText_D_A" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionA" />
                </div>
                <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionA"></el-input> -->
              </el-row>
              <el-row class="mt10">
                <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                  <el-checkbox label="B" class="mr20"></el-checkbox>
                </label>
                <div style="width: calc(100% - 100px);float: left;">
                  <RichText ref="richText_D_B" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionB" />
                </div>
                <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionB"></el-input> -->
              </el-row>
              <el-row class="mt10">
                <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                  <el-checkbox label="C" class="mr20"></el-checkbox>
                </label>
                <div style="width: calc(100% - 100px);float: left;">
                  <RichText ref="richText_D_C" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionC" />
                </div>
                <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionC"></el-input> -->
              </el-row>
              <el-row class="mt10">
                <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                  <el-checkbox label="D" class="mr20"></el-checkbox>
                </label>
                <div style="width: calc(100% - 100px);float: left;">
                  <RichText ref="richText_D_D" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionD" />
                </div>
                <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionD"></el-input> -->
              </el-row>
              <el-row class="mt10">
                <label style="float: left;width: 100px;text-align: right;line-height: 50px;">
                  <el-checkbox label="E" class="mr20"></el-checkbox>
                </label>
                <div style="width: calc(100% - 100px);float: left;">
                  <RichText ref="richText_D_E" :toolbar="false" placeholder="请输入选项内容" v-if="addShow" v-model="addInfo.questionOptionE" />
                </div>
                <!-- <el-input style="width: calc(100% - 100px);" type="textarea" :rows="2" v-model="addInfo.questionOptionE"></el-input> -->
              </el-row>
            </el-checkbox-group>
          </template>
          <!-- 判断 -->
          <template v-if="addInfo.questionType == 3">
            <el-form-item label="选项">
              <el-radio v-model="addInfo.questionAnswer" label="对" class="mr20"></el-radio>
            </el-form-item>
            <el-form-item label="">
              <el-radio v-model="addInfo.questionAnswer" label="错" class="mr20"></el-radio>
            </el-form-item>
          </template>
          <!-- 分析题 -->
          <template v-if="addInfo.questionType == 5">
            <el-form-item label="答案">
              <editorMd editorId="editorAssessmentContent5" height="300px" v-if="addShow" @onChangeContent="changeValue5" :modelValue="addInfo.questionOptionB"></editorMd>
              <!-- <el-input type="textarea" :rows="3" placeholder="请输入答案" v-model="addInfo.questionAnswer"></el-input> -->
            </el-form-item>
          </template>
          <!-- 填空题 -->
          <template v-if="addInfo.questionType == 4 || addInfo.questionType == 5">
            <el-form-item label="答案">
              <span style="color: red;">【注】需要考核的内容用  [---] 替换</span>
              <!-- <el-button type="primary" style="margin-bottom: 10px;" icon="el-icon-circle-plus-outline" @click="addSubject()"></el-button> -->
              <el-table
                border
                ref="table"
                :data="tableData4"
                style="width: calc(100% - 20px);">
                <el-table-column prop="questionName" header-align="center" align="center" label="考核题目" width="120px">
                  <template slot-scope="scope">
                    <span>第{{scope.$index + 1}}空</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="score" header-align="center" align="center" label="分值" width="120px">
                  <template slot-scope="scope">
                    <el-input :rows="3" placeholder="分值" v-model="scope.row.handsOnSimulationTasksAssessmentScore"></el-input>
                  </template>
                </el-table-column> -->
                <el-table-column prop="questionAnswer" header-align="center" align="center" label="正确答案">
                  <template slot-scope="scope">
                    <el-input type="textarea" :rows="3" placeholder="请输入考核答案" v-model="scope.row.questionAnswer"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="hj" header-align="center" align="center" label="操作" width="100px">
                  <template slot-scope="scope">
                    <el-button type="danger" @click="delSubject(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addShow = false">取 消</el-button>
          <el-button type="primary" @click="submitAddInfo">确 认</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import RichText from '@/components/RichText/index';
import {getCourseList,getCourseInfoList} from "@/common/getInfo";	//加载数据
import {loadJs} from '@/common/actions.js';
import editorMd from "@/components/editorMd/index";	//编辑器
export default {
  name: "ErrorSet",
  components: {
  	TitleInfo,
    RichText,
    editorMd
  },
  data() {
    return {
      zjie:require("../../images/course/zjie@2x.png"),
      search:{
        questionStem:"",
        teacherOpenCourseId:"",
        teacherOpenCourseMergeCourseInfoId:'',
        questionStatus:""
      },
      value1:"",
      tableData:[],
      noticeList:[], //当前页数据
      total: 0,
      limit:10,
      page:1,
      addShow:false,
      addInfo:{
        teacherOpenCourseMergeCourseInfoId:"",
        teacherOpenCourseId:"",
        questionType:1
      },
      courseList:[],
      courseInfoList:[],
      courseInfoList_add:[],
      questionAnswerList:[], //多选时使用
      teacherOpenCourseId:this.$route.query.courseId,
      teacherOpenCourseQuestionSettingId:this.$route.query.id,
      teacherOpenCourseMergeCourseInfoId:this.$route.query.mergeCourseInfoId,
      tableData4:[] //填空题
    };
  },
  computed: {
    // 新增试题时锁定的归属课程ID：优先取列表"课程筛选"的值，其次取路由带入的当前课程
    lockedCourseId(){
      return this.$isEmpty(this.search.teacherOpenCourseId) ? this.teacherOpenCourseId : this.search.teacherOpenCourseId;
    },
    // 归属课程名称（只读展示，自动跟随当前课程，无需选择）
    addInfoCourseName(){
      // 编辑态按试题自身的归属课程显示，新增态跟随当前进入的课程
      let isEdit = !this.$isEmpty(this.addInfo.teacherOpenCourseMergeResourcesQuestionId);
      let id = this.addInfo.teacherOpenCourseId || (isEdit ? "" : this.lockedCourseId);
      return this.getCourseName(id) || (isEdit ? "未识别到归属课程" : "");
    }
  },
  created() {
    loadJs();
    this.getInfo();
    this.getCourseList();
    if(!this.$isEmpty(this.teacherOpenCourseId)){
      this.getCourseInfoList(1);
    }

  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    handleCheckedCitiesChange(value){ //多选题时
      this.addInfo.questionAnswer = value.join(",");
    },
    getCourseList(){ //获取课程
      if(this.courseList.length <= 0){
        getCourseList().then((ret) =>{
          if(ret.code == 0){
            this.courseList = ret.data;
          }
        });
      }
    },
    getCourseName(id){ //根据课程ID取课程名称（课程列表拿不到时依次回退到列表数据、当前试题数据）
      if(this.$isEmpty(id)){
        return "";
      }
      let pick = (list) => {
        let name = "";
        if(!list || list.length <= 0){
          return name;
        }
        for(let i = 0; i < list.length; i++){
          if(list[i].teacherOpenCourseId == id){
            name = list[i].teacherOpenCourseIdText || list[i].teacherOpenCourseTitle || "";
            if(!this.$isEmpty(name)){
              break;
            }
          }
        }
        return name;
      };
      let name = pick(this.courseList) || pick(this.tableData);
      if(this.$isEmpty(name) && this.addInfo.teacherOpenCourseId == id){
        name = this.addInfo.teacherOpenCourseIdText || "";
      }
      return name || "当前课程";
    },
    getCourseInfoList(tag){ //获取章节
      if(tag != 1){
        this.search.teacherOpenCourseMergeCourseInfoId ="";
        this.courseInfoList = [];
      }
      getCourseInfoList({teacherOpenCourseId:this.search.teacherOpenCourseId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfoList = ret.data;
        }
      });
    },
    getCourseInfoList_add(id){
      this.courseInfoList_add = [];
      if(id != -1){
        this.addInfo.teacherOpenCourseMergeCourseInfoId = "";
      }
      getCourseInfoList({teacherOpenCourseId:this.addInfo.teacherOpenCourseId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfoList_add = ret.data;
          this.setDefaultChapter();
        }
      });
    },
    setDefaultChapter(){ //从章节练习的某一章进入时，默认带出该章节，仍可手动更换
      if(!this.$isEmpty(this.addInfo.teacherOpenCourseMergeCourseInfoId)){
        return;
      }
      let id = this.teacherOpenCourseMergeCourseInfoId;
      if(this.$isEmpty(id) || this.$isEmpty(this.courseInfoList_add)){
        return;
      }
      for(let i = 0; i < this.courseInfoList_add.length; i++){
        if(this.courseInfoList_add[i].teacherOpenCourseMergeCourseInfoId == id){
          this.addInfo.teacherOpenCourseMergeCourseInfoId = this.courseInfoList_add[i].teacherOpenCourseMergeCourseInfoId;
          return;
        }
      }
    },
    getInfo(){ //获取通知公告列表
      let param = {
        limit:this.limit,
        page:this.page,
      }
      param = Object.assign(this.search,param);
      param.teacherOpenCourseId = this.$isEmpty(this.search.teacherOpenCourseId)?this.teacherOpenCourseId:this.search.teacherOpenCourseId;
      param.teacherOpenCourseMergeCourseInfoId = this.$isEmpty(this.search.teacherOpenCourseMergeCourseInfoId)?this.teacherOpenCourseMergeCourseInfoId:this.search.teacherOpenCourseMergeCourseInfoId;
      this.$post("/api/teacherOpenCourseMergeResourcesQuestion/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    exportInfo(){ //导入信息
      this.$router.push({name:'ExportQuestion',query:{type:2}});
    },
    putShelves(item,status){ //上架
      this.$post("/jlw/teacherOpenCourseMergeResourcesQuestion/editStatus.json",{ids:item.teacherOpenCourseMergeResourcesQuestionId,status:status}).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message({type: 'success',message: '操作成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    addQuestionInfo(){ //打开添加（归属课程自动锁定为当前进入的课程，无需选择）
      let courseId = this.lockedCourseId;
      this.addInfo = {
        teacherOpenCourseId:this.$isEmpty(courseId) ? "" : courseId,
        teacherOpenCourseMergeCourseInfoId:"",
        questionType:1,
        questionAnswer:"",
        questionScore:""
      };
      this.courseInfoList_add = [];
      this.addShow = true;
      if(!this.$isEmpty(courseId)){
        this.getCourseInfoList_add(-1); //自动加载该课程章节，避免还要先选课程才出章节
      }
    },
    onScoreInput(e){ //分值输入：用原生事件兜底同步，避免中文输入法组合态下 el-input 不 emit、值只留在框里
      let raw = (e.target.value === undefined || e.target.value === null) ? "" : e.target.value;
      let val = raw.replace(/^\.+|[^\d.]/g, '');
      if(val !== raw){
        e.target.value = val;
      }
      if(this.addInfo.questionScore !== val){
        this.$set(this.addInfo, "questionScore", val);
      }
    },
    syncScoreFromDom(){ //提交前再从输入框真实值同步一次（组合被打断时事件可能根本没触发）
      let box = this.$refs.scoreInput;
      let input = box && box.$el ? box.$el.querySelector("input") : null;
      if(!input || input.value === undefined || input.value === null){
        return;
      }
      let val = input.value.replace(/^\.+|[^\d.]/g, '');
      if(val !== this.addInfo.questionScore){
        this.$set(this.addInfo, "questionScore", val);
      }
    },
    submitAddInfo(){ //提交添加
      this.syncScoreFromDom();
      if(this.$isEmpty(this.addInfo.teacherOpenCourseId)){
        this.$message({message: '未识别到归属课程，请从课程内进入该功能后重试！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(this.addInfo.teacherOpenCourseMergeCourseInfoId)){
        this.$message({message: '请选择章节！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(this.addInfo.questionType)){
        this.$message({message: '请选择题型！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(this.addInfo.questionStem)){
        this.$message({message: '请输入题干！',type: 'warning'});
        return;
      }
      let score = this.addInfo.questionScore;
      if(score === "" || score === undefined || score === null || score === "null" || isNaN(Number(score))){
        this.$message({message: '请输入题目分值！',type: 'warning'});
        return;
      }
      if(this.addInfo.questionType <= 3){ //单选、多选、判断
        if(this.$isEmpty(this.addInfo.questionAnswer)){
          this.$message({message: '请选择答案！',type: 'warning'});
          return;
        }
      }

      if(this.addInfo.questionType == 4 || this.addInfo.questionType == 5){ //填空题
        if(this.tableData4.length <= 0){
          this.$message({message: '请添加考核题目！',type: 'warning'});
          return;
        }
        let map = {};
        try {
          this.tableData4.forEach((item,i)=>{
            if(this.$isEmpty(item.questionAnswer)){
              throw new Error('请先完善填空题正确答案！');
            }
            map[i + 1] = item.questionAnswer;
          });
        } catch (e) {
          this.$message.warning(e.message);
          return
        };
        this.addInfo.questionAnswer = JSON.stringify(map);
        this.addInfo.questionOptionA = Object.keys(map).length; //用于做题时列出相应空 给学生填写
      }

      // if(this.addInfo.questionType == 5){ //填空题
      //   if(this.$isEmpty(this.addInfo.questionAnswer)){
      //     this.$message({message: '请输入答案！',type: 'warning'});
      //     return;
      //   }
      // }

      let url = "/jlw/teacherOpenCourseMergeResourcesQuestion/add.json";
      if(!this.$isEmpty(this.addInfo.teacherOpenCourseMergeResourcesQuestionId)){
        url = "/jlw/teacherOpenCourseMergeResourcesQuestion/edit.json";
      }
      this.$post(url,this.addInfo).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.addShow = false;
          this.tableData4 = [];
          //this.$refs.richText.content = ""; //清空编辑框
          this.$message({type: 'success',message: '提交成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    editInfo(item){ //编辑
      this.addInfo = item;
      if(item.questionType == 2){
        this.questionAnswerList = item.questionAnswer.split(",");
      }else if(item.questionType == 4 || item.questionType == 5){
        let map = JSON.parse(item.questionAnswer);
        let list = [];
        for(let item in map){
          list.push({questionAnswer:map[item]})
        }
        // map.forEach((item,i)=>{
        //   console.log(item,i)
        //   list[i].questionAnswer = item[i+1];
        // });
        this.tableData4 = list;
      }else{
        this.questionAnswerList = [];
        this.tableData4 = [];
      }
      this.getCourseInfoList_add(-1);
      this.addShow = true;
    },
    delInfo(item){ //删除
      this.$confirm('是否确定删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.putShelves(item,0)
        // this.$post("/jlw/teacherOpenCourseMergeResourcesQuestion/delete.json",{ids:item.teacherOpenCourseMergeResourcesQuestionId}).then((ret) =>{
        //   if(ret.code == 0){
        //     this.getInfo();
        //     this.$message({type: 'success',message: '删除成功！'});
        //   }else{
        //     this.$message({message: ret.msg,type: 'error'});
        //   }
        // });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    questionAnswerChange(){ //切换题型
      this.addInfo.questionAnswer = '';
      this.questionAnswerList = [];
      this.tableData4 = [];
    },
    addSubject(){ //添加填空题答案
      this.tableData4.push({
        score:0, //分值
        questionAnswer:"", //考核答案
      });
    },
    delSubject(index){ //删除填空题信息
      this.tableData4.splice(index,1);
    },
    changeValue(val){ // 实操考核内容 根据内容信息显示考核题目【根据[---]区分，一个[---]表示一个题目】
      this.addInfo.questionStem = val;
      if(this.addInfo.questionType == 4){
        if(!this.$isEmpty(val) && val.indexOf("[---]") >= 0){
          if(this.tableData4.length > val.split("[---]").length - 1){
            this.tableData4 = this.tableData4.slice(0,val.split("[---]").length - 1);
          }else if(this.tableData4.length < val.split("[---]").length - 1){
            let n = val.split("[---]").length - this.tableData4.length;
            for(let i=0;i<n - 1;i++){
              this.tableData4.push({
                questionName:this.$chineseNum(this.tableData4.length,1), //考核题目
                score:0, //分值
                questionAnswer:"", //考核答案
              })
            }

          }
        }else{
          this.tableData4 = [];
        }
      }
    },
    changeValue5(val){
      this.addInfo.questionOptionB = val;
      console.log(val)
      if(this.addInfo.questionType == 5){
        if(!this.$isEmpty(val) && val.indexOf("[---]") >= 0){
          if(this.tableData4.length > val.split("[---]").length - 1){
            this.tableData4 = this.tableData4.slice(0,val.split("[---]").length - 1);
          }else if(this.tableData4.length < val.split("[---]").length - 1){
            let n = val.split("[---]").length - this.tableData4.length;
            for(let i=0;i<n - 1;i++){
              this.tableData4.push({
                questionName:this.$chineseNum(this.tableData4.length,1), //考核题目
                score:0, //分值
                questionAnswer:"", //考核答案
              })
            }
          }
        }else{
          this.tableData4 = [];
        }
      }
    }
  }
};
</script>
 <style  lang="less">
  .el-ErrorSet{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }

    .editor_wrap .ql-editor {
      min-height: 100px !important;
    }

    // 归属课程只读提示
    .course-tip{
      line-height: 18px;
      font-size: 12px;
      color: #909399;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/QuestionList.vue